// extracted by mini-css-extract-plugin
export var wrapper = "InputRange_wrapper__Pa13u";
export var track = "InputRange_track__8UC-G";
export var thumb = "InputRange_thumb__RjfTx";
export var rotate = "InputRange_rotate__3tNSH";
export var dotty = "InputRange_dotty__vxOVk";